import { StoresOrdersApiService } from '@/common/services/stores-orders.api.service';
import REQUEST_STATUS from '../../common/enums/requestStatus';

export default {
  namespaced: true,

  state: {
    item: {},
    order: {},
    status: '',
  },

  getters: {
    getItem: state => state.item,
    getOrder: state => state.order,
    getStatus: state => state.status,
  },

  mutations: {
    SET_ITEM(state, data) {
      state.item = data;
    },
    SET_ORDER(state, data) {
      state.order = data;
    },
    FETCH_REQUEST(state) {
      state.status = REQUEST_STATUS.LOADING;
    },
    FETCH_SUCCESS(state) {
      state.status = REQUEST_STATUS.SUCCESS;
    },
    FETCH_FAIL(state) {
      state.status = REQUEST_STATUS.FAIL;
    },
  },

  actions: {
    fetchOrderItems({ commit, dispatch }, { url }) {
      commit('FETCH_REQUEST');

      return StoresOrdersApiService.get(url)
        .then(response => {
          commit('FETCH_SUCCESS');
          commit('SET_ORDER', response.getItem());
        })
        .catch(error => {
          dispatch('handleError', error);
        });
    },

    postOrderItems({ commit, dispatch }, { url, formData }) {
      commit('FETCH_REQUEST');

      return StoresOrdersApiService.post(url, formData)
        .then(response => {
          commit('FETCH_SUCCESS');
          commit('SET_ITEM', response.getItem());
        })
        .catch(error => {
          dispatch('handleError', error);

          return Promise.reject();
        });
    },

    handleError({ commit }, response) {
      commit('FETCH_FAIL');

      const message = response.getFirstValidationErrorMessage() || response.getMessage();

      if (message) {
        try {
          const response = JSON.parse(message);

          try {
            this.$app.$alertError(
              response.PacketAttributesFault.attributes.fault.find(fault => fault.name === 'addressId').fault
            );
          } catch (e) {
            this.$app.$alertError('Neočekávaná chyba');
          }
        } catch (e) {
          this.$app.$alertError(message);
        }
      }
    },
  },
};
